<template>
	<SuiModal v-model="isModalOpen">
		<i
			class="close icon"
			@click="closeModal"
		/>

		<SuiModalContent
			style="padding: 0 !important;"
		>
			<div
				class="c-illustration-modal-body"
			>
				<div
					class="c-illustration-modal-body__hero"
					:class="{ 'c-illustration-modal-body__hero--generator-ai': modalType === 'signUpGeneratorAI' || lastModalType === 'signUpGeneratorAI'}"
				/>
				<div
					class="c-illustration-modal-body__content"
					style="justify-content: center; align-items: center"
				>
					<TransitionExpand>
						<div v-if="signViaMagicResponse === null">
							<div
								v-if="modalType.includes('signUp') || lastModalType.includes('signUp')"
								class="c-sign-popup"
							>
								<h2 class="c-sign-popup__header c-heading c-heading--third">
									<span v-if="modalType === 'signUp' || lastModalType === 'signUp'">
										{{ $t('header.extendYourStay') }}
									</span>
									<span v-if="modalType === 'signUpAction' || lastModalType === 'signUpAction'">
										{{ $t('header.firstCreateAnAccount') }}
									</span>
									<span v-if="modalType === 'signUpCreateDeck' || lastModalType === 'signUpCreateDeck'">
										{{ $t('header.createYourFirstDeck') }}
									</span>
									<span v-if="modalType === 'signUpGeneratorAI' || lastModalType === 'signUpGeneratorAI'">
										{{ $t('header.createWithAIHeader') }}
									</span>
								</h2>
								<p
									v-if="modalType === 'signUp' || lastModalType === 'signUp'"
									class="c-sign-popup__subheader p"
								>
									{{ $t('header.signUpForFreeMultideckerAccount') }}
								</p>
								<p
									v-if="modalType === 'signUpAction' || lastModalType === 'signUpAction'"
									class="c-sign-popup__subheader p"
								>
									{{ $t('header.onceYouCreatedYourAccount') }}
								</p>
								<p
									v-if="modalType === 'signUpCreateDeck' || lastModalType === 'signUpCreateDeck'"
									class="c-sign-popup__subheader p"
								>
									{{ $t('header.signUpForFreeMultideckerAccountShort') }}
								</p>
								<p
									v-if="modalType === 'signUpGeneratorAI' || lastModalType === 'signUpGeneratorAI'"
									class="c-sign-popup__subheader p"
								>
									{{ $t('header.createWithAISubheader') }}
								</p>
								<div class="c-sign-popup__newsletter">
									<label>
										<input
											v-model="newsletter"
											type="checkbox"
											value="newsletter"
										>
										{{ $t('header.yesNewsletter') }}
									</label>
								</div>
								<div v-if="!signViaEmailActive">
									<a
										v-if="false"
										:href="`/auth/login/facebook?newsletter=${this.newsletter}&redirect=${redirect}`"
										class="c-sign-popup__button ui facebook button"
										:class="{ loading: busyButton === 'facebook' }"
										@click="sign('signUp', 'Facebook')"
									>
										<i class="facebook icon" />
										{{ $t('header.signUpFacebook') }}
									</a>
									<br>
									<a
										:href="`/auth/login/google?newsletter=${this.newsletter}&redirect=${redirect}`"
										class="c-sign-popup__button ui google plus button"
										:class="{ loading: busyButton === 'google' }"
										@click="sign('signUp', 'Google')"
									>
										<i class="google icon" />
										{{ $t('header.signUpGoogle') }}
									</a>
									<br>
									<a
										href="#"
										class="c-sign-popup__button ui black plus button"
										@click.prevent="sign('signUp', 'Email')"
									>
										<i class="envelope icon" />
										{{ $t('header.signUpEmail') }}
									</a>
								</div>
								<div>
									<!-- TODO: pass redirect here and there? -->
									<SignViaEmail
										v-if="signViaEmailActive"
										:redirect="redirect"
										:newsletter="newsletter"
										sign-type="sign-up"
										:back-to-sign-options="backToSignOptions"
										@sign-magic-response="onSignMagicResponse"
									/>
									<div
										v-if="signViaEmailActive === false && (modalType.includes('signUp') || lastModalType.includes('signUp'))"
										class="c-sign-popup__terms"
									>
										{{ $t('header.bySigningUpYouAgreeToOur') }}
										<RouterLink
											:to="{ name: 'privacyPolicy' }"
											@click.native="closeModal"
										>
											{{ $t('privacyPolicy') }}.
										</RouterLink>
									</div>
									<div class="p c-sign-popup__switch_sign-type">
										{{ $t('header.alreadyHaveAnAccount') }}
										<a
											href
											class="c-sign-popup__link"
											@click.prevent="changeModalToSignIn"
										>
											{{ $t('header.signIn') }}
										</a>
									</div>
								</div>
							</div>
							<div
								v-if="modalType === 'signIn' || lastModalType === 'signIn'"
								class="c-sign-popup"
							>
								<h2 class="c-sign-popup__header c-heading c-heading--third">
									{{ $t("header.welcomeBack") }}
								</h2>
								<p class="c-sign-popup__subheader p">
									{{ $t("header.signInToGetAccess") }}
								</p>

								<div v-if="!signViaEmailActive">
									<div class="c-sign-popup__newsletter">
										<label>
											<input
												v-model="newsletter"
												type="checkbox"
												value="newsletter"
											>
											{{ $t('header.yesNewsletter') }}
										</label>
									</div>

									<a
										:href="`/auth/login/facebook?newsletter=${this.newsletter}&redirect=${redirect}`"
										class="c-sign-popup__button ui facebook button"
										:class="{ loading: busyButton === 'facebook' }"
										@click="sign('signIn', 'Facebook')"
									>
										<i class="facebook icon" />
										{{ $t("header.loginFacebook") }}
									</a>
									<br>
									<a
										:href="`/auth/login/google?newsletter=${this.newsletter}&redirect=${redirect}`"
										class="c-sign-popup__button ui google plus button"
										:class="{ loading: busyButton === 'google' }"
										@click="sign('signIn', 'Google')"
									>
										<i class="google icon" />
										{{ $t("header.loginGoogle") }}
									</a>
									<br>
									<a
										href="#"
										class="c-sign-popup__button ui black plus button"
										@click.prevent="sign('signIn', 'Email')"
									>
										<i class="envelope icon" />
										{{ $t('header.loginEmail') }}
									</a>
								</div>
								<SignViaEmail
									v-if="signViaEmailActive"
									:redirect="redirect"
									:newsletter="newsletter"
									sign-type="sign-in"
									:back-to-sign-options="backToSignOptions"
									@sign-magic-response="onSignMagicResponse"
								/>
								<div class="p c-sign-popup__switch_sign-type">
									{{ $t('header.noAccount') }} <a
										href
										class="c-sign-popup__link"
										@click.prevent="changeModalToSignUp"
									>
										{{ $t('header.createOne') }}
									</a>
								</div>
							</div>
						</div>
					</TransitionExpand>
					<TransitionExpand>
						<div v-if="signViaMagicResponse !== null">
							<div class="c-sign-popup">
								<div v-if="signViaMagicResponse.res.data.success">
									<h2 class="c-sign-popup__header c-heading c-heading--third">
										<span>{{ $t('header.checkYourInbox') }}</span>
									</h2>
									<div
										v-if="signViaMagicResponse.intention === 'sign-in'"
										class="c-sign-popup__sign-feedback"
									>
										<p>{{ $t('header.clickTheLinkToSignIn', { email: signViaMagicResponse.destination }) }}</p>
									</div>
									<div
										v-if="signViaMagicResponse.intention === 'sign-up'"
										class="c-sign-popup__sign-feedback"
									>
										<p>{{ $t('header.clickTheLinkToSignUp', { email: signViaMagicResponse.destination }) }}</p>
									</div>
								</div>
								<div v-else-if="signViaMagicResponse.res.data.error.code === 1001">
									<h2 class="c-sign-popup__header c-heading c-heading--third">
										<span>{{ $t('header.weDidntRecognizeThatEmail') }}</span>
									</h2>
									<p>{{ $t('header.wouldYouLikeToSignInWithDifferentEmail') }}</p>
									<SignViaEmail
										v-if="signViaEmailActive"
										:redirect="redirect"
										:newsletter="newsletter"
										sign-type="sign-in"
										:back-to-sign-options="backToSignOptions"
										@sign-magic-response="onSignMagicResponse"
									/>
									<div class="p c-sign-popup__switch_sign-type">
										{{ $t('header.noAccount') }}
										<a
											href
											class="c-sign-popup__link"
											@click.prevent="changeModalToSignUp"
										>
											{{ $t('header.createOne') }}
										</a>
									</div>
								</div>
							</div>
						</div>
					</TransitionExpand>
				</div>
			</div>
		</SuiModalContent>
	</SuiModal>
</template>
<script>
import { logAnalyticsEvent, events } from '@/assets/js/utils/analytics';
import SignViaEmail from '@/components/signModal/SignViaEmail';
import TransitionExpand from '@/components/TransitionExpand';

export default {
	name: 'SignModal',
	components: { TransitionExpand, SignViaEmail },
	props: {
		modalType: String,
		modalRedirect: String,
	},
	data() {
		return {
			events,
			isModalOpen: false,
			lastModalType: '',
			busyButton: '',
			newsletter: false,
			signViaEmailActive: false,
			signViaMagicResponse: null,
		};
	},
	computed: {
		redirect() {
			if (this.modalRedirect) {
				return this.modalRedirect;
			}
			if (['notAuthorized401', 'notFound404', 'showcase'].includes(this.$route.name)) {
				return '/dashboard';
			}

			return this.$route.fullPath;
		},
	},
	watch: {
		modalType(newVal) {
			this.isModalOpen = newVal != '';

			if (newVal != '') {
				this.signViaMagicResponse = null;
				this.lastModalType = newVal;
			}
		},
		isModalOpen(newVal) {
			if (newVal === false) {
				this.signViaMagicResponse = null;
				this.signViaEmailActive = false;
				this.closeModal();
			}
		},
	},
	methods: {
		backToSignOptions() {
			this.signViaMagicResponse = null;
			this.signViaEmailActive = false;
		},
		sign(type, provider) {
			logAnalyticsEvent(...events[`${type}${provider}`]);
			this.busyButton = provider.toLowerCase();

			if (provider === 'Email') {
				this.signViaEmailActive = true;
			}
		},
		changeModalToSignIn() {
			this.$store.dispatch('changeModalType', 'signIn');
		},
		changeModalToSignUp() {
			this.signViaEmailActive = false;
			this.$store.dispatch('changeModalType', 'signUp');
		},
		closeModal() {
			this.$store.dispatch('changeModalType', '');
		},
		onSignMagicResponse(res) {
			this.signViaMagicResponse = res;
		},
	},
};
</script>
<style scoped>
.c-illustration-modal-body__hero {
	--c-illustration-modal-background-image: url('/img/teacher-1.png'), url("data:image/jpeg;base64,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");
	--c-illustration-modal-min-height: 450px;
	--c-illustration-modal-width: 280px;
}

.c-illustration-modal-body__hero--generator-ai {
	--c-illustration-modal-background-image: url('/img/robot.png');
}
</style>
